import {
  alias,
  arrayOf as arrayOfType,
  bool as boolType,
  client,
  number as numberType,
  params,
  shape as shapeType,
  string as stringType,
} from '@thd-nucleus/data-sources';

export const pipCalculatorDataModel = {
  clientOnlyProduct: alias('product').params({
    itemId: stringType().isRequired()
  }).shape({
    dataSources: stringType(),
    // TODO: maybe we don't need this and we can keep it in buybox?
    fulfillment: client(params({ storeId: stringType() }).shape({
      fulfillmentOptions: arrayOfType(shapeType({
        type: stringType(),
        fulfillable: boolType(),
      }))
    })),
    info: shapeType({
      pipCalculator: shapeType({
        coverageUnits: stringType(), // Dimensional units Ex: "Panel", "Block", "Sheet", "Bag"
        display: boolType(), // Whether or not to display the calculator
        publisher: numberType(), // units per case
        toggle: stringType() // "2-Point" (sq. ft.) or "3-Point" (cu. ft.)
      })
    }),
    installServices: params({ storeId: stringType() }).shape({
      scheduleAMeasure: boolType()
    }),
    pricing: params({ storeId: stringType() }).shape({
      unitOfMeasure: stringType(),
      alternate: shapeType({
        bulk: shapeType({
          thresholdQuantity: numberType({ float: true }),
          value: numberType({ float: true })
        }),
        unit: {
          caseUnitOfMeasure: stringType()
        }
      }),
      value: numberType({ float: true })
    }),
    taxonomy: shapeType({
      breadCrumbs: arrayOfType(shapeType({
        label: stringType()
      }))
    })
  })
};

export const samDataModel = {
  product: params({
    itemId: stringType().isRequired()
  }).shape({
    dataSources: stringType(),
    pricing: params({ storeId: stringType() }).shape({
      alternate: shapeType({
        unit: {
          unitsPerCase: stringType(),
          value: stringType()
        }
      })
    }),
    specificationGroup: arrayOfType(shapeType({
      specTitle: stringType(),
      specifications: arrayOfType(shapeType({
        specName: stringType(),
        specValue: stringType()
      }))
    })),
    taxonomy: shapeType({
      breadCrumbs: arrayOfType(shapeType({
        label: stringType()
      }))
    })
  })
};